

<div class="wtf-animation">
  <div class="letters">
    <span class="first">SOL</span>
    <span class="second">NATI</span>
    <span class="third">VO</span>
    <span class="admin">admin</span>
  </div>

  <div class="form-container">
    <form [ngClass]="{form: true, firstTime: firstTime}" *ngIf="step === 1" [formGroup]="authForm" (submit)="sendForm1($event);">

      <div class="header">
        Sign In
      </div>

      <div class="auth-from-field">
        <mat-form-field >
          <mat-label>Email</mat-label>
          <input matInput type="text" formControlName="login">

          <button matSuffix mat-icon-button aria-label="Clear" (click)="clear('login')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-error *ngIf="!authForm.controls.login.valid && authForm.controls.login.touched"> {{firstError(authForm.controls.login.errors)}} </mat-error>
      </div>

      <div class="auth-from-field">
      <mat-form-field>
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password">

        <button matSuffix mat-icon-button aria-label="Clear" (click)="clear('login')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
        <mat-error *ngIf="!authForm.controls.password.valid && authForm.controls.password.touched"> {{firstError(authForm.controls.password.errors)}} </mat-error>
      </div>

      <div class="auth-btn">

        <button mat-flat-button>NEXT</button>
      </div>

      <div class="auth-btn">
        <button mat-flat-button type="button" (click)="reset()">RESET PASSWORD</button>

      </div>

    </form>


    <form class="form"  *ngIf="step === 2" [formGroup]="authForm2" (submit)="sendForm2($event);">
      <div class="header">
        Step 2
      </div>

      <div class="auth-from-field">
        <mat-form-field>
          <mat-label>Code</mat-label>
          <input matInput type="text" formControlName="code">

          <button matSuffix mat-icon-button aria-label="Clear" (click)="clear2('code')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-error *ngIf="!authForm2.controls.code.valid && authForm2.controls.code.touched"> {{firstError(authForm2.controls.code.errors)}} </mat-error>
      </div>

      <div class="auth-btn">

        <button mat-flat-button>NEXT</button>
      </div>

      <div class="auth-btn">
        <button mat-flat-button type="button" (click)="back()">Back</button>

      </div>
    </form>
    <form class="form"  *ngIf="step === 3" [formGroup]="authForm3" (submit)="sendForm3($event);">
      <div class="header">
        Reset Pass
      </div>

      <div class="auth-from-field">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="login">

          <button matSuffix mat-icon-button aria-label="Clear" (click)="clear3('login')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-error *ngIf="!authForm3.controls.login.valid && authForm3.controls.login.touched"> {{firstError(authForm3.controls.login.errors)}} </mat-error>
      </div>

      <div class="auth-btn">

        <button mat-flat-button>NEXT</button>
      </div>

      <div class="auth-btn">
        <button mat-flat-button type="button" (click)="back()">Back</button>

      </div>
    </form>
    <form class="form"  *ngIf="step === 4" [formGroup]="authForm4" (submit)="sendForm4($event);">
      <div class="header">
        Reset Code
      </div>

      <div class="auth-from-field">
        <mat-form-field>
          <mat-label>Code</mat-label>
          <input matInput type="text" formControlName="code">

          <button matSuffix mat-icon-button aria-label="Clear" (click)="clear4('code')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-error *ngIf="!authForm4.controls.code.valid && authForm4.controls.code.touched"> {{firstError(authForm4.controls.code.errors)}} </mat-error>
      </div>


      <div class="auth-btn">

        <button mat-flat-button>NEXT</button>
      </div>

      <div class="auth-btn">
        <button mat-flat-button type="button" (click)="back()">Back</button>

      </div>
    </form>
  </div>

</div>
